import React, { PureComponent } from 'react';
import { TextField as TextFieldMaterial } from '@material-ui/core';
import red from '@material-ui/core/colors/red';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

class TextField extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isDirty: false,
    };
  }

  renderError = () => {
    const {
      classes, maxLength, value, errortext, required,
    } = this.props;
    const { isDirty } = this.state;

    if (maxLength
      && value
      && value.length > maxLength) {
      return (
        <p className={classes.errorMessage}>
          Maximal
          {' '}
          {maxLength}
          {' '}
          Zeichen erlaubt
        </p>
      );
    }

    if (required && isDirty && !value) {
      return (<p className={classes.errorMessage}>Dieses Feld ist ein Pflichtfeld</p>);
    }

    if (errortext) {
      return (<p className={classes.errorMessage}>{errortext}</p>);
    }

    return null;
  }

  handleChange = (event) => {
    const { onChange } = this.props;

    this.setState({
      isDirty: true,
    });

    onChange(event);
  }

  render() {
    const {
      classes, fullWidth, placeholder, label, type, value, multiline, rows, style, InputLabelProps, InputProps,
      disabled, ...other

    } = this.props;

    return (
      <div style={fullWidth ? { width: '100%' } : null}>
        <TextFieldMaterial
          {...other}
          className={classes.root}
          fullWidth={fullWidth}
          placeholder={placeholder}
          label={label}
          type={type}
          value={value || ''}
          onChange={this.handleChange}
          multiline={multiline}
          rows={rows}
          style={style}
          InputLabelProps={{
            className: classes.label,
            ...InputLabelProps,
          }}
          InputProps={{
            ...InputProps,
          }}
          disabled={disabled}
          error={this.renderError() !== null}
        />
        {this.renderError()}
      </div>
    );
  }
}

TextField.propTypes = {
  value: PropTypes.any,
  required: PropTypes.bool,
  maxLength: PropTypes.number,
  classes: PropTypes.object.isRequired,
  InputProps: PropTypes.object,
  errortext: PropTypes.string,
  fullWidth: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  style: PropTypes.object,
  InputLabelProps: PropTypes.object,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

TextField.defaultProps = {
  onChange: () => {},
  value: '',
  placeholder: '',
  required: false,
  maxLength: null,
  InputProps: null,
  errortext: null,
  fullWidth: false,
  label: '',
  multiline: false,
  rows: 0,
  style: null,
  InputLabelProps: null,
  type: 'text',
  disabled: false,
};

const styles = () => ({
  root: {
    marginTop: 14,
    display: 'flex',
  },
  errorMessage: {
    color: red[500],
    fontSize: 10,
    marginTop: 3,
  },
  label: {
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    paddingTop: '2px',
  },
});

export default withStyles(styles)(TextField);
